// src/components/Footer.js
import React from "react";
import { useTranslation } from "react-i18next";
import '../Footer.css';
const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-dark text-white py-4">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center gap-2">
        <div className="text-white-50">
          © {new Date().getFullYear()} {t("footer.t1")}
        </div>
        <div className="d-flex gap-3">
          <a className="text-white-50 text-decoration-none" href="/home">
            {t("footer.t2")}
          </a>
          <a className="text-white-50 text-decoration-none" href="/services">
            {t("footer.t3")}
          </a>
          <a className="text-white-50 text-decoration-none" href="./login">
            {t("footer.t4")}
          </a>
          <a className="text-white-50 text-decoration-none" href="/contact">
            {t("footer.t5")}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;